import type { ValidationErrorCode } from '@atlassian/ai-managed-objects/validation';

import type { messages } from '../../common/messages';

export const validationErrorMessageKeys: Record<ValidationErrorCode, keyof typeof messages> = {
	EMPTY_PROMPT: 'emptyPrompt',
	INVALID_DESIRED_UPDATE_FREQUENCY: 'invalidDesiredUpdateFrequency',
	MISSING_GOAL: 'missingGoal',
	MISSING_OUTPUT_FORMAT: 'missingOutputFormat',
	MISSING_SOURCES: 'missingSources',
	SOURCES_INVALID: 'sourceInvalidError',
	SOURCES_PENDING: 'sourcePendingError',
	SOURCES_REQUIRED: 'sourceRequiredError',
};
